module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurLarge/Battles-BC.77a395f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurLarge/Battles-BC.jpg
// module id = V9c7
// module chunks = 0